import config from "../config";

export const fetchTimeZone = async (lat, lng, timestamp) => {
    const url = 
    `${config.API.googleTimeZoneAPI}?location=${lat},${lng}&timestamp=${timestamp}&key=${config.GOOGLETIMEZONEAPIKEY}`;
    const res = await fetch(url);
    const data = await res.json();

    if (data.status === "OK") {
        const totalOffsetSeconds = data.rawOffset + data.dstOffset;
        const offsetInHours = totalOffsetSeconds / 3600;

        const hours = Math.floor(offsetInHours);
        const minutes = Math.abs((offsetInHours - hours) * 60);

        const formattedOffset = "UTC" + (offsetInHours >= 0 ? "+" : "-") +
                String(Math.abs(hours)).padStart(2, '0') + ":" + String(minutes).padStart(2, '0');
            
        return {data, formattedOffset};
    }
    return { data: null, formattedOffset: null };
}